import { render } from "./DetailRevisi.vue?vue&type=template&id=27814af2&scoped=true"
import script from "./DetailRevisi.vue?vue&type=script&lang=js"
export * from "./DetailRevisi.vue?vue&type=script&lang=js"

import "./DetailRevisi.vue?vue&type=style&index=0&id=27814af2&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27814af2"]])

export default __exports__